const { alpha, Grid, Typography } = require('@mui/material');
const { Box } = require('@mui/system');
const PropTypes = require('prop-types');

PaymentMethod.propTypes = {
  selected: PropTypes.bool,
  setPaymentMethod: PropTypes.func.isRequired,
  imgSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export function PaymentMethod({ selected, setPaymentMethod, imgSrc, label }) {
  return (
    <Box
      width={250}
      sx={(theme) => ({
        bgcolor: selected ? alpha(theme.palette.primary.main, 0.12) : '#ececec',
        border: selected ? `2px solid ${theme.palette.primary.main}` : null,
        cursor: 'pointer',
        ':hover': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
        },
      })}
      bgcolor={selected ? 'primary.main' : '#ececec'}
      p={2}
      borderRadius={1}
      onClick={setPaymentMethod}
    >
      <Grid container spacing={2} alignItems={'center'}>
        <Grid container item sm={4} position={'relative'} justifyContent={'center'}>
          <img src={imgSrc} alt={label} style={{ objectFit: 'contain' }} height={20} />
        </Grid>
        <Grid item sm={8}>
          <Typography>{label}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
